import { type ErrorDetail, type MessagePayload } from "@/shared/webworker";

export enum MapDataEvent {
  Error = "error",
  Initialized = "initialized",
}

export interface MapDataEventPayloadMap {
  [MapDataEvent.Error]: ErrorDetail | Error;
  [MapDataEvent.Initialized]: undefined;
}

export function isErrorEvent(
  event: MessageEvent<MessagePayload>,
): event is MessageEvent<
  MessagePayload<MapDataEvent, MapDataEventPayloadMap[MapDataEvent.Error]>
> {
  return event.data.type === MapDataEvent.Error;
}

export function isInitializedEvent(
  event: MessageEvent<MessagePayload>,
): event is MessageEvent<
  MessagePayload<MapDataEvent, MapDataEventPayloadMap[MapDataEvent.Initialized]>
> {
  return event.data.type === MapDataEvent.Initialized;
}
